import styled from "styled-components";

export const RegisterDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: Hug (1570px);
  height: 160px;
  top: 167px;
  border-radius: 4px;
  /* overflow-x: hidden; */
  background: white;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-right: 50px;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 15px;
`;

export const RowDiv333 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
`;

export const Titlep = styled.header`
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 22px;
  margin-right: 31px;
  /* Admin/Body/B1-16 R */
  font-family: "Noto Sans KR";

  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400;
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;

export const Reddot = styled.div`
  color: #ff1717;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;

export const TextInput = styled.input`
  width: 450px;
  height: 35px;
  left: 120px;
  border-radius: 2px;
  border: 1px solid #e8e8e8;
  padding: 2px 10px;
  font-family: "Noto Sans KR";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 21px */

  &::placeholder {
    opacity: 0.2;
  }
`;

export const Pubp = styled.header`
  display: flex;
  flex-direction: row;
  width: 85px;
  height: 22px;
  margin-right: 46px;
  font-family: "Noto Sans KR";

  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400;
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;

export const Datep = styled.header`
  display: flex;
  flex-direction: row;
  width: 69px;
  height: 22px;
  margin-right: 61px;
  font-family: "Noto Sans KR";

  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400;
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;

export const Label = styled.header`
  margin-right: 20px;
  margin-left: 6px;
  font-family: "Noto Sans KR";
  color: #000;
  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body2};
  font-weight: ${(props) => props.theme.fontWeights.Body2};
  line-height: ${(props) => props.theme.LineHeight.Body2};
`;

export const PublishHint = styled.span`
  margin-left: 8px;
  color: #ff1717;
  font-family: "Noto Sans KR";
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
`;

export const ImgDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  /* 상단 폼 카드(RegisterDiv)와 동일한 오른쪽 여백으로 가로 끝을 맞춘다. */
  margin-right: 50px;
`;

